import { useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { useNavigate } from "react-router-dom";

const TABS = [
  { key: "", label: "All" },
  { key: "pending_review", label: "Pending Review" },
  { key: "processing", label: "Processing" },
  { key: "published", label: "Published" },
];

export default function AdminReviewQueue() {
  const [tab, setTab] = useState("pending_review");
  const [looks, setLooks] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const params = tab ? { status: tab } : {};
    api.get("/admin/looks", { params }).then((r) => setLooks(r.data));
  }, [tab]);

  return (
    <div className="fade-in">
      <p className="overline mb-2">AI Extraction</p>
      <h1 className="font-serif text-4xl font-light mb-8">Review Queue</h1>

      <div className="flex gap-2 mb-8 border-b border-white/10 pb-4">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`review-tab-${t.key || "all"}`}
            onClick={() => setTab(t.key)}
            className={`text-xs px-4 py-2 rounded-full border transition-all ${
              tab === t.key ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "border-white/15 text-[#8E8E9A] hover:text-[#F8F6F0]"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {looks.map((l) => (
          <button
            key={l.id}
            onClick={() => navigate(`/admin/review/${l.id}`)}
            data-testid={`review-look-${l.id}`}
            className="group text-left bg-[#141417] border border-white/5 hover:border-[#D4AF37]/40 rounded-sm overflow-hidden transition-all"
          >
            <div className="aspect-video overflow-hidden bg-[#0B0B0C]">
              {l.hero_thumbnail && <img src={mediaUrl(l.hero_thumbnail)} alt="" className="w-full h-full object-cover img-zoom" />}
            </div>
            <div className="p-4">
              <div className="flex items-center justify-between mb-2">
                <StatusBadge status={l.status} />
                <span className="font-mono text-[10px] text-[#8E8E9A]">{(l.category_summary || []).join(" · ")}</span>
              </div>
              <h3 className="font-serif text-xl font-light group-hover:text-[#D4AF37] transition-colors">{l.title}</h3>
              <p className="text-xs text-[#8E8E9A] mt-1 font-light truncate">{l.processing_message}</p>
            </div>
          </button>
        ))}
        {looks.length === 0 && <p className="text-[#8E8E9A] font-light">No looks in this state.</p>}
      </div>
    </div>
  );
}
